import Notice from './Notice';

export default Notice
export { Notice as Base }
